import clsxm from "@/lib/clsxm";
import {memo, type FC} from "react";
import {useTranslation} from "react-i18next";

type TSegmentedToggleOption = {
  label: string;
  onClick: () => void;
};

const SegmentedToggle: FC<{
  className?: string;
  options: TSegmentedToggleOption[];
  selectedIndex: number;
  titleClassName?: string;
}> = ({className, options, selectedIndex, titleClassName}) => {
  const {t} = useTranslation();

  return (
    <div
      className={clsxm(
        "border-primary-light-solid flex h-10 max-w-96 grow items-center justify-center overflow-hidden rounded-full border",
        className,
      )}>
      {options.map((option, index) => (
        <div
          key={index}
          onClick={option.onClick}
          className={clsxm(
            "flex h-full flex-1 cursor-pointer items-center justify-center text-center text-sm font-medium transition-colors",
            index === 0 && "rounded-l-full",
            index === options.length - 1 && "rounded-r-full",
            index === selectedIndex
              ? "bg-primary-dark-solid text-white"
              : "text-neutral-grey-light hover:bg-neutral-grey-lightest bg-white",
            titleClassName,
          )}>
          {t(option.label)}
        </div>
      ))}
    </div>
  );
};

export default memo(SegmentedToggle);
